import { number, object } from 'yup'

const pointSchema = object({
  x: number().required(),
  y: number().required(),
  z: number().required(),
})

export const alignOpeningsSchema = object({
  globalStart: pointSchema,
  globalEnd: pointSchema,
})
